import { faPlay, faQuestionCircle, faEnvelope, faBroadcastTower, faStream, faCode, faCodeBranch, faChartBar, faDatabase, faClock, faFloppyDisk, faBrain, faUsers, faBug, faGlobe, faPaperPlane, faNetworkWired, faComments, faCheckDouble, faClipboardList, faShareNodes, faBullhorn, faChartLine,
    faKey, faUserTag, faStopwatch, faChartPie, faWandMagicSparkles, faSeedling, faHandshake, faEnvelopesBulk } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faFacebookSquare } from '@fortawesome/free-brands-svg-icons';

const iconMap = {
    inject:               faPlay,
    email:                faEnvelope,
    webhook:              faNetworkWired,
    function:             faCode,
    delay:                faClock,
    debug:                faBug,
    httprequest:          faGlobe,
    facebook:             faFacebook,
    facebooksendmessage:  faPaperPlane,
    facebookconversations: faComments,
    aianalysis:           faBrain,
    savedata:             faFloppyDisk,
    customer:             faUsers,
    switch:               faCodeBranch,
    report:               faChartBar,
    data:                 faDatabase,
    event:                faBroadcastTower,
    pushnotification:     faPaperPlane,
    zalosendmessage:      faPaperPlane,
    channelsendmessage:   faShareNodes,
    adssync:              faBullhorn,
    facebookpostinsights: faChartLine,
    facebookcreatepost:   faFacebookSquare,
    foreachitem:          faStream,
    checkaction:          faCheckDouble,
    userform:             faClipboardList, 
    // Node của GÓI MARKETING. Thiếu ở đây thì node vẫn chạy nhưng hiện dấu hỏi — trông như lỗi.
    facebooktokenrenew:   faKey,
    leadassign:           faUserTag,
    leadslacheck:         faStopwatch,
    marketingrollup:      faChartPie,
    aimarketing:          faWandMagicSparkles,
    leadnurture:          faSeedling,
    leadconvert:          faHandshake,
    marketingblast:       faEnvelopesBulk,
    default:              faQuestionCircle
};

export default iconMap;